/* eslint-disable no-magic-numbers */

import {
  FetchBadRequest,
  FetchConflictRequest,
  FetchForbiddenRequest,
  FetchInternalServerError,
  FetchNotFoundRequest,
  FetchUnauthorizedRequest,
  FetchWithCode,
  ResourceError,
} from "./Errors";
import { ApiFn } from "use-async-resource";

export default function handleNotOkResponse<T extends ApiFn<unknown, any[]>>(
  res: Response,
  apiFunction: T,
  body?: any
): never {
  switch (res.status) {
    case 400:
      throw new FetchBadRequest(apiFunction, "Bad request", body);
    case 401:
      throw new FetchUnauthorizedRequest(apiFunction, "Unauthorized");
    case 403:
      throw new FetchForbiddenRequest(apiFunction, "Forbidden");
    case 404:
      throw new FetchNotFoundRequest(apiFunction, "Not found");
    case 409:
      throw new FetchConflictRequest(apiFunction, "Conflict", body);
    case 500:
      throw new FetchInternalServerError(apiFunction, "Internal Server Error");
    default:
      throw new FetchWithCode(apiFunction, res.statusText).setCode(res.status);
  }
}

export function handleNotOkResponseByResourceError<
  T extends ApiFn<unknown, any[]>
>(resourceError: ResourceError<T>, apiFunction: T): never {
  switch (resourceError.constructor) {
    case FetchBadRequest:
      throw new FetchBadRequest(apiFunction, "Bad request");
    case FetchUnauthorizedRequest:
      throw new FetchUnauthorizedRequest(apiFunction, "Unauthorized");
    case FetchForbiddenRequest:
      throw new FetchForbiddenRequest(apiFunction, "Forbidden");
    case FetchNotFoundRequest:
      throw new FetchNotFoundRequest(apiFunction, "Not found");
    case FetchConflictRequest:
      throw new FetchConflictRequest(apiFunction, "Conflict");
    case FetchInternalServerError:
      throw new FetchInternalServerError(apiFunction, "Internal Server Error");
    default:
      throw new ResourceError(apiFunction, "Resource error");
  }
}
